$(document).on('ready turbolinks:load ajax:success', function() {
  $('.file-input').each(function () {
    const $inputWrapper = $(this);
    const $dropArea = $inputWrapper.find('.file-input__drop-area');
    const $input = $inputWrapper.find('input');
    const isMultiple = $input.prop('multiple');
    const highlightClass = 'file-input__drop-area--highlight';

    $dropArea.on('dragenter dragover dragleave drop', preventDefaults);
    $dropArea.on('dragenter dragover', highlight);
    $dropArea.on('dragleave drop', unhighlight);
    $dropArea.on('drop', e => generateList(e, 'drop'));
    $input.on('change', e => generateList(e, 'change'));

    function preventDefaults (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    function highlight(e) {
      $dropArea.addClass(highlightClass);
    }
    function unhighlight(e) {
      $dropArea.removeClass(highlightClass);
    }

    const $filesListWrap = $(`
      <div class="file-input__list-wrap">
        <div class="file-input__list-header">
          <p class="file-input__list-title">Files</p>
          <button class="file-input__list-clear" type="button" onclick="onClearFiles()">
            Clear All
          </button>
        </div>
      </div>
    `);
    const $filesList = $('<ul class="file-input__list">');
    const $fileItem = name => $(`<li class="file-input__file">${name}</li>`);

    onClearFiles = () => {
      $input.val('');
      $filesList.html('');
      $filesListWrap.hide();
    };

    $filesListWrap.append($filesList);

    function generateList ({ originalEvent: e }, type) {
      let files;

      switch (type) {
        case 'drop':
          files = e.dataTransfer.files
          $input[0].files = files;
          break;

        case 'change':
          files = e.target.files
          break;
      }

      $filesList.html('');

      if (isMultiple) {
        $(files).each(function (index) {
          $filesList.append($fileItem(this.name));
        });
      } else {
        $filesList.append($fileItem(files[0].name));
      }

      if ($inputWrapper.has($filesListWrap).length) {
        $filesListWrap.show();
      } else {
        $dropArea.after($filesListWrap);
      }
    }

  });
});
